import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import { Container, CircularProgress, Box, Grid } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { get, post, put } from "src/utils/networkUtils";
import moment from "moment";
import DivisionLeaderboardDialog from "src/components/stage-admin/DivisionLeaderboardDialog";
import AddVersusPackDialog from "src/components/profile/AddVersusPackDialog";
import AddCoinsDialog from "src/components/profile/AddCoinsDialog";
import AddXpDialog from "src/components/profile/AddXpDialog";
import AddTicketsDialog from "src/components/profile/AddTicketsDialog";
import LoginStreakDateDialog from "src/components/profile/LoginStreakDateDialog";
import ImitateLoginDialog from "src/components/profile/ImitateLoginDialog";
import ReferralCodeDialog from "src/components/profile/ReferralCodeDialog";
import CreateLeagueDialog from "src/components/profile/CreateLeagueDialog";
import JoinLeagueDialog from "src/components/profile/JoinLeagueDialog";
import AllAccessPassDialog from "src/components/profile/AllAccessPassDialog";
import UserMenuPopover from "src/components/profile/UserMenuPopover";
import ProfileTabsSection from "src/components/profile/ProfileTabsSection";
import ProfileTopBlock from "src/components/profile/ProfileTopBlock";
import ProfileUserData from "src/components/profile/ProfileUserData";
import ProfileUserStats from "src/components/profile/ProfileUserStats";

const dateFormat = "YYYY-MM-DD HH:mm:ss";
export default function ProfilePage() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [transactions, setTransactions] = useState(null);
  const [ticketTransactions, setTicketTransactions] = useState(null);
  const [purchases, setPurchases] = useState([]);
  const [userLevel, setUserLevel] = useState(null);
  const [userLevelStats, setUserLevelStats] = useState(null);
  const [divisionLeagues, setDivisionLeagues] = useState(null);
  const [messages, setMessages] = useState(null);
  const [adminMessages, setAdminMessages] = useState(null);
  const [versusContracts, setVersusContracts] = useState(null);
  const [openAddCoinsDialog, setOpenAddCoinsDialog] = useState(false);
  const [openAddVersusPackDialog, setOpenAddVersusPackDialog] = useState(false);
  const [openAddTicketsDialog, setOpenAddTicketsDialog] = useState(false);
  const [openReferralCodeDialog, setOpenReferralCodeDialog] = useState(false);
  const [openCreateLeagueDialog, setOpenCreateLeagueDialog] = useState(false);
  const [openJoinLeagueDialog, setOpenJoinLeagueDialog] = useState(false);
  const [openLoginStreakDatesDialog, setOpenLoginStreakDatesDialog] =
    useState(false);
  const [openImitateLoginDialog, setOpenImitateLoginDialog] = useState(false);
  const [selectedDivisionLeagueId, setSelectedDivisionLeagueId] =
    useState(null);
  const [addCoinsAmount, setAddCoinsAmount] = useState(0);
  const [addTicketsAmount, setAddTicketsAmount] = useState(0);
  const [referralCode, setReferralCode] = useState("");
  const [leagueName, setLeagueName] = useState("");
  const [leagueCode, setLeagueCode] = useState("");
  const [loginStreakDates, setLoginStreakDates] = useState({
    loginStreakStartDate: moment().format(dateFormat),
    lastLoginDate: moment().format(dateFormat),
  });
  const [loginDate, setLoginDate] = useState({
    date: moment().format(dateFormat),
  });
  const [userId, setUserId] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const [value, setValue] = useState(0);
  const [versusTabValue, setVersusTabValue] = useState(0);
  const [openAllAccessPassDialog, setOpenAllAccessPassDialog] = useState(false);
  const [storePrice, setStorePrice] = useState("1299");
  const [storeType, setStoreType] = useState("Apple");
  const [periodType, setPeriodType] = useState("Weekly");
  const [localizedPrice, setLocalizedPrice] = useState(12.99);
  const [transactionCurrency, setTransactionCurrency] = useState("USD");
  const [versusPackType, setVersusPackType] = useState("0");
  const [openAddXpDialog, setOpenAddXpDialog] = useState(false);
  const [addXpAmount, setAddXpAmount] = useState(0);
  const [open, setOpen] = useState(null);

  useEffect(() => {
    if (searchParams.has("user_id")) {
      let userId = searchParams.get("user_id");
      setUserId(userId);
      get(`/admin/users/${userId}`).then(function (response) {
        setUser(response.user);
        setLoginStreakDates({
          loginStreakStartDate: moment(
            response.user?.loginStreakStartUtc
          ).format(dateFormat),
          lastLoginDate: moment(response.user?.lastLoginUtc).format(dateFormat),
        });
      });
      get(`/admin/users/${userId}/coin-transactions?offset=0&limit=200`).then(
        function (response) {
          setTransactions(response.transactions);
        }
      );
      get(`/admin/users/${userId}/division-leagues?offset=0&limit=200`).then(
        function (response) {
          setDivisionLeagues(response.leagues);
        }
      );
      get(`/admin/users/${userId}/store-purchases?offset=0&limit=100`).then(
        function (response) {
          setPurchases(response.purchases);
        }
      );

      get(`/admin/users/${userId}/ticket-transactions?offset=0&limit=100`).then(
        function (response) {
          setTicketTransactions(response.transactions);
        }
      );

      get(`/admin/user-admin-inbox-messages/${userId}?offset=0&limit=50`).then(
        function (response) {
          setAdminMessages(response.adminInboxMessages);
        }
      );
      get(`/admin/user-inbox-messages/${userId}?offset=0&limit=100`).then(
        function (response) {
          setMessages(response.userInboxMessages);
        }
      );
      get(`/admin/versus/users/${userId}/contracts`).then(function (response) {
        setVersusContracts(response.contracts);
      });
      get(`/admin/users/${userId}/level-stats`).then(function (response) {
        setUserLevelStats(response.attributes);
        setUserLevel(response.level);
      });
      get(`/admin/versus/users/${userId}/contracts`).then(function (response) {
        setVersusContracts(response.contracts);
      });
    } else {
    }
  }, [setSearchParams, searchParams, navigate]);

  const handleChangeTabs = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeVersusTabs = (event, newValue) => {
    setVersusTabValue(newValue);
  };

  const handleOpenMenu = (event) => {
    setOpen(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const addCoinsHandler = () => {
    post(`/admin/coins/add`, {
      userId,
      amount: addCoinsAmount,
      tenantId: 1,
    }).then(function (response) {
      window.location.reload(true);
    });
  };
  const addVersusPackHandler = () => {
    post(`/admin/versus/users/${userId}/packs`, {
      packType: versusPackType,
      tenantId: 1,
    }).then(function (response) {
      window.location.reload(true);
    });
  };
  const addXpHandler = () => {
    post(`/admin/xp/add`, {
      userId,
      amount: addXpAmount,
      tenantId: 1,
    }).then(function (response) {
      window.location.reload(true);
    });
  };

  const addAllAccessPassHandler = () => {
    post(`/admin/all-access/add`, {
      userId,
      price: storePrice,
      store: storeType,
      period: periodType,
      localizedPrice: Number(localizedPrice),
      transactionCurrency: String(transactionCurrency),
    }).then(function (response) {
      window.location.reload(true);
    });
  };
  const addTicketsHandler = () => {
    post(`/admin/tickets/add`, {
      userId,
      amount: addTicketsAmount,
      tenantId: 1,
    }).then(function (response) {
      window.location.reload(true);
    });
  };
  const addReferralCodeHandler = () => {
    post(`/admin/users/${userId}/add-referral-code`, {
      referralCode,
    }).then(function (response) {
      window.location.reload(true);
    });
  };

  const updateLoginStreakDatesHandler = () => {
    setLoading(true);
    setOpenLoginStreakDatesDialog(false);
    put(`/admin/users/${userId}/login-dates`, {
      loginStreakStartDate: loginStreakDates.loginStreakStartDate,
      lastLoginDate: loginStreakDates.lastLoginDate,
    }).then(function (response) {
      window.location.reload(true);
    });
  };
  const imitateLoginHandler = () => {
    setLoading(true);
    setOpenImitateLoginDialog(false);
    post(`/admin/users/${userId}/imitate-login`, {
      date: loginDate.date,
    }).then(function (response) {
      window.location.reload(true);
    });
  };
  const createLeagueHandler = () => {
    setLoading(true);
    setOpenCreateLeagueDialog(false);
    post(`/admin/users/${userId}/leagues`, {
      name: leagueName,
    }).then(function (response) {
      window.location.reload(true);
    });
  };
  const joinLeagueHandler = () => {
    setLoading(true);
    setOpenJoinLeagueDialog(false);
    post(`/admin/users/${userId}/join-league`, {
      code: leagueCode,
    }).then(function (response) {
      window.location.reload(true);
    });
  };
  const handleDateChange = (newValue, fieldName) => {
    setLoginStreakDates((prevState) => ({
      ...prevState,
      [fieldName]: moment(newValue).format(dateFormat),
    }));
  };
  const handleLoginDateChange = (newValue, fieldName) => {
    setLoginDate((prevState) => ({
      ...prevState,
      [fieldName]: moment(newValue).format(dateFormat),
    }));
  };

  const updateUserField = (field, value) => {
    if (!userId) return;

    const updatedUser = {
      ...user,
      [field]: value,
    };

    return put(`/admin/users/${userId}`, { ...updatedUser })
      .then((response) => {
        setUser(updatedUser);
        return response;
      })
      .catch((err) => {
        console.error("Error updating user:", err.response?.data || err.message);
        throw err; // propagate rejection
      });
  };
  return (
    <>
      <Helmet>
        <title> Profile </title>
      </Helmet>
      <Container maxWidth="xl">
        {loading ? (
          <Box
            sx={{ display: "flex", justifyContent: "center" }}
            style={{ padding: 20 }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <>
            {user && userLevelStats && userLevel && (
              <ProfileTopBlock
                user={user}
                userLevelStats={userLevelStats}
                userLevel={userLevel}
              />
            )}
            {user && userLevelStats && userLevel && (
              <ProfileUserData
                user={user}
                userLevelStats={userLevelStats}
                userLevel={userLevel}
                onSaveField={updateUserField}
              />
            )}
            {user && userLevelStats && userLevel && (
              <ProfileUserStats
                user={user}
                userLevelStats={userLevelStats}
                userLevel={userLevel}
              />
            )}

            <Grid container spacing={3}>
              <ProfileTabsSection
                value={value}
                handleChangeTabs={handleChangeTabs}
                handleOpenMenu={handleOpenMenu}
                userId={userId}
                transactions={transactions}
                purchases={purchases}
                divisionLeagues={divisionLeagues}
                messages={messages}
                adminMessages={adminMessages}
                versusContracts={versusContracts}
                ticketTransactions={ticketTransactions}
                versusTabValue={versusTabValue}
                userLevel={userLevel}
                userLevelStats={userLevelStats}
                handleChangeVersusTabs={handleChangeVersusTabs}
                setOpenAddCoinsDialog={setOpenAddCoinsDialog}
                setOpenAllAccessPassDialog={setOpenAllAccessPassDialog}
                setOpenReferralCodeDialog={setOpenReferralCodeDialog}
                setOpenAddXpDialog={setOpenAddXpDialog}
                setSelectedDivisionLeagueId={setSelectedDivisionLeagueId}
                setOpenAddVersusPackDialog={setOpenAddVersusPackDialog}
                setOpenAddTicketsDialog={setOpenAddTicketsDialog}
              />
            </Grid>
          </>
        )}
      </Container>
      {openAddVersusPackDialog && (
        <AddVersusPackDialog
          open={openAddVersusPackDialog}
          onClose={() => setOpenAddVersusPackDialog(false)}
          versusPackType={versusPackType}
          setVersusPackType={setVersusPackType}
          addVersusPackHandler={addVersusPackHandler}
        />
      )}
      {openAddCoinsDialog && (
        <AddCoinsDialog
          open={openAddCoinsDialog}
          addCoinsAmount={addCoinsAmount}
          setAddCoinsAmount={setAddCoinsAmount}
          addCoinsHandler={addCoinsHandler}
          setOpenAddCoinsDialog={setOpenAddCoinsDialog}
        />
      )}

      {openAddXpDialog && (
        <AddXpDialog
          open={openAddXpDialog}
          setOpen={setOpenAddXpDialog}
          addXpAmount={addXpAmount}
          setAddXpAmount={setAddXpAmount}
          addXpHandler={addXpHandler}
        />
      )}

      {openAddTicketsDialog && (
        <AddTicketsDialog
          open={openAddTicketsDialog}
          onClose={() => setOpenAddTicketsDialog(false)}
          addTicketsAmount={addTicketsAmount}
          setAddTicketsAmount={setAddTicketsAmount}
          addTicketsHandler={addTicketsHandler}
        />
      )}
      {openLoginStreakDatesDialog && (
        <LoginStreakDateDialog
          open={openLoginStreakDatesDialog}
          onClose={() => setOpenLoginStreakDatesDialog(false)}
          loginStreakDates={loginStreakDates}
          handleDateChange={handleDateChange}
          updateLoginStreakDatesHandler={updateLoginStreakDatesHandler}
        />
      )}

      {openImitateLoginDialog && (
        <ImitateLoginDialog
          open={openImitateLoginDialog}
          onClose={() => setOpenImitateLoginDialog(false)}
          onConfirm={imitateLoginHandler}
          loginDate={loginDate}
          handleLoginDateChange={handleLoginDateChange}
        />
      )}
      {openReferralCodeDialog && (
        <ReferralCodeDialog
          open={openReferralCodeDialog}
          onClose={() => setOpenReferralCodeDialog(false)}
          referralCode={referralCode}
          setReferralCode={setReferralCode}
          onAdd={addReferralCodeHandler}
        />
      )}
      {openCreateLeagueDialog && (
        <CreateLeagueDialog
          open={openCreateLeagueDialog}
          onClose={() => setOpenCreateLeagueDialog(false)}
          leagueName={leagueName}
          setLeagueName={setLeagueName}
          onCreate={createLeagueHandler}
        />
      )}

      {openJoinLeagueDialog && (
        <JoinLeagueDialog
          open={openJoinLeagueDialog}
          onClose={() => setOpenJoinLeagueDialog(false)}
          onJoin={joinLeagueHandler}
          leagueCode={leagueCode}
          setLeagueCode={setLeagueCode}
        />
      )}

      {selectedDivisionLeagueId !== null && (
        <DivisionLeaderboardDialog
          divisionLeagueId={selectedDivisionLeagueId}
          open={selectedDivisionLeagueId !== null}
          onClose={() => setSelectedDivisionLeagueId(null)}
        />
      )}

      {openAllAccessPassDialog && (
        <AllAccessPassDialog
          open={openAllAccessPassDialog}
          onClose={() => setOpenAllAccessPassDialog(false)}
          onSubmit={addAllAccessPassHandler}
          storePrice={storePrice}
          setStorePrice={setStorePrice}
          storeType={storeType}
          setStoreType={setStoreType}
          periodType={periodType}
          setPeriodType={setPeriodType}
          localizedPrice={localizedPrice}
          setLocalizedPrice={setLocalizedPrice}
          transactionCurrency={transactionCurrency}
          setTransactionCurrency={setTransactionCurrency}
        />
      )}

      <UserMenuPopover open={open} onClose={handleCloseMenu} userId={userId} />
    </>
  );
}
